import { CURRENT_REP_CREATE,
         CURRENT_REP_UPDATE } from '../constants/currentRepTypes';

export function currentRepCreate(params) {
  return {
    type: CURRENT_REP_CREATE,
    payload: params
  };
}

export function currentRepUpdate(params) {
  return {
    type: CURRENT_REP_UPDATE,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/currentRepActions.js